require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-nachmittagsbetreuung-2023-24.json") })
        }
      }, "path---kriterien-nachmittagsbetreuung-2023-24");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-nachmittagsbetreuung-2023-24!./.cache/json/kriterien-nachmittagsbetreuung-2023-24.json
// module id = 1083
// module chunks = 231608221292675